import * as classNames from 'classnames';
import * as React from 'react';
import style from '../import_tool.less';

interface ImportMappingSelectorProps extends React.ClassAttributes<any> {
    name: string;
    structure: any;
    selectedValue: any;
    keyChecked: boolean;
    usedValues: Array<string>;
    korrigieren: boolean; // obsolete?
    ubernehmen: boolean; // obsolete?
    onChange(field: string, target: string): void;
    onKeyChange(field: string, checked: boolean): void;
}

interface WImportStepMappingSelectorState {
    korrigieren: boolean;
}

export class ImportMappingSelector extends React.Component<ImportMappingSelectorProps, WImportStepMappingSelectorState> {

    constructor(props: any) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyChange = this.onKeyChange.bind(this);
        this.state = {
            korrigieren: this.props.korrigieren
        };
    }

    render() {
        const selectedValue = this.props.selectedValue;
        if (!selectedValue && !(this.props.usedValues || []).length) {
            this.matchValue(this.props.structure.ATTS, this.props.name);
        }
        const usedValues = this.props.usedValues ? this.props.usedValues : [];
        // console.log('Selected value: ' + this.props.name + ' -> ' + selectedValue);
        return (
            <div className={style.rowContainer}>
                <div className={classNames(style.flexItem, style.w200)}>
                    {this.props.name}
                </div>
                <div className={style.flexItem}>
                    <select
                        className={style.w300}
                        onChange={this.onChange}
                        value={selectedValue ? selectedValue : 'UNUSED'}
                    >
                        <option value='UNUSED'>
                            Nicht importieren
                        </option>
                        {this.props.structure.ATTS
                            .filter((att: any) => usedValues.indexOf(att.KEY) === -1 || selectedValue === att.KEY)
                            .map((att: any) => this.renderOption(att))
                        }
                    </select>
                    {false && // Erstmal raus, da Schlüssel-Info über die Struktur kommt
                        <label className={style.mini_info}>
                        <input
                            type='checkbox'
                            checked={this.props.keyChecked}
                            disabled={!selectedValue || selectedValue === 'UNUSED'}
                            onChange={this.onKeyChange}
                        />
                            Schlüsselfeld
                        </label>
                    }
                </div>
            </div>
        );
    }

    private matchValue(atts: Array<any>, name: string) {
        const found = atts.find((att: any) =>  {
            // console.log('Match ' + name , att);
            return att.NAME === name;
        });
        if (found) {
            this.props.onChange(this.props.name, found.KEY);
        }
    }

    private renderOption(att: any) {
        const required: boolean = typeof att.REQUIRED !== 'undefined' && (att.REQUIRED.toString().toLowerCase() === 'key');
        // const required: boolean = typeof att.REQUIRED !== 'undefined' && (+att.REQUIRED === 1 || att.REQUIRED.toString().toLowerCase() === 'yes');
        return (
            <option
                key={`att_${att.KEY}`}
                value={att.KEY}
            >
                {att.NAME}{required ? ' <Schlüsselfeld>' : ''}
            </option>
        );
    }

    private onChange(event: any) {
        console.log('Set Mapping: ' + this.props.name + ' -> ' + event.target.value);
        this.props.onChange(this.props.name, event.target.value);
        if (this.state.korrigieren) {
            this.setState({ korrigieren: false });
        }
    }

    private onKeyChange(event: any) {
        this.props.onKeyChange(this.props.name, event.target.checked);
    }
}
